import * as GC from '@grapecity/spread-sheets';
import { toSpreadsheetColumnName } from '@helpers/spread/column-parser';
import { sharedRegex } from '@helpers/spread/shared-regex';
import { DATATABLETYPE_COL_POS, DEFAULT_FIELDS, DIMENSION_COL_POS, MNEMONIC_COL_POS, NAME_COL_POS, RESULT_TYPE_COL_POS } from './constants';

export const addDataTableTypeValidator = (sheet: GC.Spread.Sheets.Worksheet, datatableTypes, row: number) => {
  const dvDatatableType = GC.Spread.Sheets.DataValidation.createListValidator(datatableTypes.join(','));
  dvDatatableType.ignoreBlank(false);
  if (!sheet.getCell(row, DATATABLETYPE_COL_POS).value()) {
    sheet.getCell(row, DATATABLETYPE_COL_POS).value(DEFAULT_FIELDS.DATATABLE_TYPE);
  }
  sheet.setDataValidator(row, DATATABLETYPE_COL_POS, dvDatatableType);
};

export const addDimensionValidator = (sheet: GC.Spread.Sheets.Worksheet, row: number) => {
  const dvDimensions = GC.Spread.Sheets.DataValidation.createListValidator('1,2,3');
  dvDimensions.ignoreBlank(false);
  sheet.setDataValidator(row, DIMENSION_COL_POS, dvDimensions);
};

export const addInterpolationValidator = (sheet: GC.Spread.Sheets.Worksheet, interpolation, row: number, col: number) => {
  const dvInterpolation = GC.Spread.Sheets.DataValidation.createListValidator(interpolation.join(','));
  dvInterpolation.ignoreBlank(false);
  sheet.setDataValidator(row, col, dvInterpolation);
};

export const addDefinitionValidator = (sheet: GC.Spread.Sheets.Worksheet, dimensionDefinition, row: number, col: number) => {
  const dvDefinition = GC.Spread.Sheets.DataValidation.createListValidator(dimensionDefinition.map(x => x.name).join(','));
  dvDefinition.ignoreBlank(false);
  sheet.setDataValidator(row, col, dvDefinition);
};
export const isEmptyLookupSetupRowFormula = (rowNumber: number, colNumber: number): string => {
  return `OR(COUNTBLANK(A${rowNumber}:N${rowNumber})=14), AND(COUNTBLANK(A${rowNumber}:N${rowNumber})=13, ${toSpreadsheetColumnName(
    colNumber
  )}${rowNumber}=0)`;
};

export const addAccountNameValidatorToRow = (sheet: GC.Spread.Sheets.Worksheet, r: number) => {
  // Row is non-empty, cell is non-empty, and unique in its column
  const row = r + 1;
  const col = NAME_COL_POS;

  const AccountNameValidator = GC.Spread.Sheets.DataValidation.createFormulaValidator(`
  OR(
    ${isEmptyLookupSetupRowFormula(row, col + 1)},
    NOT(ISBLANK(A${row}))
  )
  `);
  AccountNameValidator.ignoreBlank(false);
  sheet.setDataValidator(r, col, AccountNameValidator);
};

export const addMnemonicValidatorToRow = (sheet: GC.Spread.Sheets.Worksheet, r: number) => {
  // Row is non-empty, cell is non-empty, and unique in its column
  // Mnemonic filed should on accept letters, numbers, underscores (_). It should not allow spaces.

  const row = r + 1;
  const col = MNEMONIC_COL_POS;

  const condition = `
    OR(
      ${isEmptyLookupSetupRowFormula(row, col + 1)},
      AND(
        NOT(ISBLANK(B${row})),
        NOT(OR(ISNUMBER(SEARCH("~?",B${row})), ISNUMBER(SEARCH("~*",B${row})), ISNUMBER(SEARCH("~~",B${row})))),
        COUNTIF(B:B,B${row}) = 1,
        IF(B${row}="",TRUE,IF(ISERROR(SUMPRODUCT(SEARCH(MID(B${row},
          ROW(INDIRECT("1:"&LEN(B${row}))),1),
          "${sharedRegex.mnemonicAcceptedCharacters}"))),FALSE,TRUE)),
        NOT(COUNTIF(Validation!A:A, B${row}))
      )
    )
    `;

  const MnemonicValidation = GC.Spread.Sheets.DataValidation.createFormulaValidator(condition);
  MnemonicValidation.errorMessage('Invalid Mnemonic');
  MnemonicValidation.ignoreBlank(false);
  sheet.setDataValidator(r, col, 1, 1, MnemonicValidation);
};

export const addResultTypeValidatorToRow = (sheet: GC.Spread.Sheets.Worksheet, r: number): any => {
  const col = RESULT_TYPE_COL_POS;
  sheet.getCell(r, col).value(DEFAULT_FIELDS.RESULT_TYPE);
};

export const addValidationToRow = (sheet: GC.Spread.Sheets.Worksheet, datatableTypes, row: number) => {
  if (row >= 0) {
    addAccountNameValidatorToRow(sheet, row);
    addMnemonicValidatorToRow(sheet, row);
    addResultTypeValidatorToRow(sheet, row);
    addDataTableTypeValidator(sheet, datatableTypes, row);
    addDimensionValidator(sheet, row);
    // this.isSheetValid = this.isSheetValid && this.isValidRow(row);
  }
};

export const removeValidationFromRow = (sheet: GC.Spread.Sheets.Worksheet, row: number) => {
  sheet.setDataValidator(row, 0, 1, sheet.getColumnCount(), null);
};
